import {injectRuleSet} from '@jetbrains/ring-ui-built/components/global/inject-styles'
import {renderToStaticMarkup} from 'react-dom/server'

import BitbucketBlackIcon from './svg/bitbucket-black.svg?react'
import BitbucketDisabledIcon from './svg/bitbucket-disabled.svg?react'
import GitlabIcon from './svg/gitlab.svg?react'

const values = [false, true]
values.forEach(disabled => {
  injectRuleSet(`.tc-icon_bitbucket${disabled ? '_disabled' : ''}`, {
    background: `url('data:image/svg+xml;utf8,${encodeURIComponent(renderToStaticMarkup(disabled ? <BitbucketDisabledIcon /> : <BitbucketBlackIcon />))}')`,
    'background-size': '140% 140%',
    'background-position': '50% 55%',
  })
})

injectRuleSet(
  `.tc-icon_gitlab,
  .tc-icon_gitlab_disabled,
  .tc-icon_gitlab-enterprise,
  .tc-icon_gitlab-enterprise_disabled`,
  {
    background: `url('data:image/svg+xml;utf8,${encodeURIComponent(
      renderToStaticMarkup(<GitlabIcon xmlns="http://www.w3.org/2000/svg" />),
    )}')`,
    'background-size': '110%',
    'background-position': '50% 55%',
  },
)
